import React from 'react';
import { connect } from 'react-redux';
import { checkedAllItems, onChange, onChangeItem, onChangeInformation } from './../../../../../actions/addOrder';
import ItemsComponent from './../../../components/items';
import dataRow from './../../../components/items/dataRow';
import RowItem from './RowItem';
import './styles.css';
import { iconEmpty } from './../../../../../services/helper'

class Items extends ItemsComponent {
    constructor(props) {
        super(props)

        this.addRowDefault()
    }

    addRowDefault = () => {
        let recordDefault = []
        let data = dataRow()

        recordDefault.push(data)
        this.props.onChangeItem(recordDefault)
    }

    renderRow = () => {
        let items = [...this.props.itemOrder]
        if (!items.length) {
            return (
                <tr>
                    <td colSpan={11}>{iconEmpty()}</td>
                </tr>
            )
        }

        return items.map((value, key) => {
            return <RowItem
                itemData={value}
                key={key}
                no={key + 1}
                maxSizeSku={this.props.maxSizeSku}
                validateEmpty={this.props.validateEmpty}
                prohibitedItems={this.props.prohibitedItems}
            />
        })
    }
}

const mapStateToProps = state => {
    return {
        itemOrder: state.addOrder.items,
        order: state.addOrder
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeItem: payload => {
            dispatch(onChangeItem(payload))
        },
        checkedAllItems: payload => {
            dispatch(checkedAllItems(payload))
        },
        onChange: payload => {
            dispatch(onChange(payload))
        },
        onChangeInformation: payload => {
            dispatch(onChangeInformation(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Items)



// WEBPACK FOOTER //
// ./src/containers/orders/add/components/items/index.js